import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import PointCloudViewer from "./PointCloudViewer";
import pointcould_logo from "./pointcould_logo.png";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "London",
      //value: "./data/db0a300e8848f7368c0cabba1eb47db7.ply"
      value: "",
      valueLoaded: false
    };
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  handleFileChange(event) {
    this.setState({ valueLoaded: false, value: event.target.value }, () => {
      this.setState({ valueLoaded: true });
    });
    console.log("FILE CHANGED, Value = " + event.target.value);
  }

  componentDidMount() {
    this.setState(
      { value: "./data/db663e3f7ee9869f5c351e299b24e355.ply" },
      () => {
        this.setState({ valueLoaded: true });
      }
    );
  }

  render() {
    return (
      <div className="App">
        <div className="App-logo">
          <img src={pointcould_logo} className="App-logo2" alt="logo" />
        </div>

        {this.state.valueLoaded ? (
          <div /*className="viewer-holder"*/>
            <PointCloudViewer data={this.state.value} />
          </div>
        ) : (
          <div /*className="viewer-holder"*/>NOTHING</div>
        )}

        <div className="leftNav">
          <div className="small-text">SELECT A MODEL</div>
          <select
            className="select-css"
            value={this.state.value}
            onChange={this.handleFileChange}
          >
            <option value="./data/db663e3f7ee9869f5c351e299b24e355.ply">
              Camera
            </option>
            <option value="./data/db0a300e8848f7368c0cabba1eb47db7.ply">
              Shark
            </option>
            <option value="./data/420f6d4f07c3109bee5e7ed304cc3a4c.ply">
              Apple
            </option>
            <option value="./data/2d01483c696c0a1688be2a30dd556a09.ply">
              Biplane
            </option>
            <option value="./data/f94fe93a63234c0c54e499d8b00afd63.ply">
              Banjo
            </option>
            <option value="./data/CAR_7a228c811e7e18ad18e1879dc4ad8784.ply">
              Car
            </option>
          </select>
        </div>
        <div className="data-info-footer">
          Data provided by: Walter Wohlkinger, Aitor Aldoma Buchaca, Radu Rusu,
          Markus Vincze. “3DNet: Large-Scale Object Class Recognition from CAD
          Models”. In IEEE International Conference on Robotics and Automation
          (ICRA), 2012.{" "}
          <a
            href="https://strands.pdc.kth.se/public/3DNet_Dataset/"
            target="_blank"
          >
            https://strands.pdc.kth.se/public/3DNet_Dataset/
          </a>
        </div>
      </div>
    );
  }
}

export default App;
